<script>
	export let loading = false;
	export let disabled = false;
	export let className = '';

	// eslint-disable-next-line no-unused-vars
	$: props = (({ loading, className, ...rest }) => rest)($$props);
</script>

{#if props.type === 'submit'}
	<button
		disabled={loading || disabled}
		class="focus:outline-none flex justify-center {className}"
		class:opacity-60={loading || disabled}
		{...props}
	>
		{#if loading}
			<div class="mr-2 btn-spinner" />
		{/if}
		<slot />
	</button>
{:else}
	<button
		disabled={loading || disabled}
		class="focus:outline-none flex justify-center {className}"
		{...props}
		on:click|preventDefault
		class:opacity-60={loading || disabled}
	>
		{#if loading}
			<div class="mr-2 btn-spinner" />
		{/if}
		<slot />
	</button>
{/if}
